import React from 'react';
import Header from './../Shared/Components/Header/Header';
import Hero from '../../Assets/Images/ContactUs/contact.jpg';
import HeroMob from '../../Assets/Images/ContactUs/contact.jpg';
import ContactForm from './Components/ContactForm';
import TextRow from './../Shared/Components/TextRow/TextRow';
import ContactMethods from './Components/ContactMethods';
import { Helmet } from "react-helmet";

const ContactUs = () => {
    return (
        <>
            <Helmet>
                <html lang="en" />
                <title>The Sustainability Academy | Talk about the SDGs</title>
                <meta name="description" content="If you want to join our journey to help create sustainable future then we would love to talk " />

            </Helmet>

            <Header
                headerImage={Hero}
                headerImageMob={HeroMob}
                lineText="Hello"
                title="Contact Us"
                subtitle="Let's see if we can help" />

            <TextRow
                title="Get In Touch"
                lineText="We are here to help"
                paragraph="Make the next step on your organisation's sustainability journey and engage all colleagues in your strategy, for a free consultation please get in touch today."
            >
                <ContactMethods />
                <ContactForm />
            </TextRow>
        </>
    );
};

export default ContactUs;